import { Flex, Loader as Spinner, MantineProvider } from '@mantine/core';

export function Loader() {
  return (
    <MantineProvider withNormalizeCSS withGlobalStyles inherit theme={{ colorScheme: 'light' }}>
      <Flex mih="100vh" justify="center" align="center">
        <Spinner />
      </Flex>
    </MantineProvider>
  );
}
